import styled from '@emotion/styled';

import { Step } from 'pages/AutomationEngine/types/automation';

import { TFunction, useTranslation } from 'react-i18next';

import StepCard from '__pages/AutomationEngine/Engine/Steps/StepCard';
import { VariableSource } from '__pages/AutomationEngine/dialogs/VariableWizard/types';
import { HistoryVariableValue } from '__pages/AutomationEngine/HistoryFrameWork';
import { getDescriptionValue } from './getDescriptionValue';

const Container = styled.span`
  font-size: 1.4em;
  * {
    font-size: 1em;
  }
`;

export const content = ({ step }: { step: Step }) =>
  step.history?.[0]?.detailedLog ? (
    <HistoryVariableValue detailedLog={step.history[0].detailedLog} />
  ) : (
    <Container dangerouslySetInnerHTML={{ __html: step.description }} />
  );

type GetDescription = {
  step: VariableSource;
  t: TFunction;
};

export const getDescription = ({ step, t }: GetDescription) => {
  const { details } = step;
  const { descriptionValue, descriptionPlural } = getDescriptionValue({
    details,
    t,
  });
  return t(`‘{{variableName}}’ = {{descriptionValue}}{{descriptionPlural}}`, {
    variableName: details.variable.name,
    descriptionValue,
    descriptionPlural,
  });
};

type CardProps = {
  type: 'initialize_variable';
  step: Step;
  title: string;
};

export default function VariableInitializationCard({
  step,
  title,
  ...others
}: CardProps) {
  const { t } = useTranslation();
  return (
    <StepCard {...others} title={step.history ? t('Variable') : title}>
      {content({ step })}
    </StepCard>
  );
}
